<template>
    <v-container>
        <!--   Diálogo para Mostrar un mensaje al Enviar la Lista de Estudiantes     -->
        <v-dialog v-model="dialogSendList" max-width="600px">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_send_list')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogSendList = false"
                    >No
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="sendList()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para mostrar un mensaje de confirmacion al transferir estudiantes     -->
        <v-dialog v-model="dialog_transfer_confirm" max-width="600px">
            <v-card>
                <v-card-title class="headline">
                    {{$t('transfer_confirm')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialog_transfer_confirm = false"
                    >No
                    </v-btn>
                    <v-btn
                            color="primary"
                            :loading="loading_transfer_confirm"
                            @click="transferStudents()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Lista de Estudiantes por Salón  -->
        <v-dialog v-model="dialogListStudentsByClassroom" persistent scrollable max-width="700px">
            <v-card>
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{$t('attendance_list')}}
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogListStudentsByClassroom = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <template v-if="dataListStudents.length !== 0 && !bandAlreadyPassedList" v-slot:extension>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        fab
                                        color="blue"
                                        bottom
                                        left
                                        absolute
                                        :disabled="selected.length === 0"
                                        @click="sendList()"
                                >
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('save_list')}}</span>
                        </v-tooltip>
                    </template>
                </v-toolbar>
                <v-card-text>
                    <div v-if="dataListStudents.length !== 0">
                        <v-data-table
                                v-model="selected"
                                :headers="bandAlreadyPassedList === true ? headers3 : headers2"
                                :items="dataListStudents"
                                :single-select="singleSelect"
                                item-key="id"
                                :show-select="!bandAlreadyPassedList"
                                class="elevation-1"
                                hide-default-footer
                                :items-per-page="-1"
                        >
                            <template v-slot:item.avatar="{ item }">
                                <v-avatar
                                        class="profile"
                                        color="grey"
                                        size="50"
                                >
                                    <v-img :src="item.avatar">
                                    </v-img>
                                </v-avatar>
                            </template>
                            <template  v-if="bandAlreadyPassedList === true" v-slot:item.status="{ item }">
                                <v-tooltip v-if="item.status === 0" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                dark
                                                color="primary"
                                                class="mr-2"
                                                :loading="loading"
                                                @click="changeAttendanceStudent(false, item.id)"
                                        >
                                            <v-icon>mdi-check</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('remove_assistance')}}</span>
                                </v-tooltip>
                                <v-tooltip v-if="item.status === -1" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                dark
                                                color="red"
                                                class="mr-2"
                                                :loading="loading"
                                                @click="changeAttendanceStudent(true, item.id)"
                                        >
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('add_assistance')}}</span>
                                </v-tooltip>
                                <v-tooltip v-if="item.status > 0" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                small
                                                color="primary"
                                                class="mr-2"
                                                disabled
                                        >
                                            <v-icon>mdi-check</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{$t('attended')}}</span>
                                </v-tooltip>
                            </template>
                            <template  v-if="bandAlreadyPassedList === true" v-slot:item.id="{ item }">
                                <div v-if="item.status === -1">
                                    {{$t('did_not_attend')}}
                                </div>
                                <div v-if="item.status === 0 && getProfile.express_check_out === false">
                                    <v-btn
                                            color="primary"
                                            @click="signExitPass(item.id)"
                                    >
                                        {{$t('sign_exit')}}
                                    </v-btn>
                                </div>
                                <div v-if="item.status === 0 && getProfile.express_check_out === true">
                                    <v-btn
                                            color="green"
                                            :loading="loading"
                                            @click="createExpressExit(item.id)"
                                    >
                                        {{$t('registrar_salidas')}}
                                    </v-btn>
                                </div>
                                <div v-if="item.status === 3">
                                    {{$t('transferred')}}
                                </div>
                                <div v-if="item.status === 1">
                                    <v-icon color="green">mdi-check</v-icon>
                                    {{$t('signed')}}
                                </div>
                                <div v-if="item.status === 2">
                                    {{$t('out_of_school')}}
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                    <div v-else class="text-center">
                        <h2>{{$t('no_assigned_students')}}</h2>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Lista de Estudiantes por Salón para Firmar Pase de Salida  -->
        <v-dialog v-model="dialogListStudentSignExitPass" persistent scrollable max-width="700px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('transfer_students')}}
                    </v-toolbar-title>
                    <v-spacer/>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogListStudentSignExitPass = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div v-if="dataListStudentsToSignExitPass.length !== 0">
                        <br>
                        <h3>{{$t('step')}} 1</h3>
                        <p>{{$t('select_students_to_transferred')}}</p><v-divider/>
                        <v-data-table
                                v-model="studentsSelectedToTransfer"
                                :headers="headers2"
                                :items="dataListStudentsToSignExitPass"
                                :single-select="singleSelect"
                                show-select
                                item-key="id"
                                class="elevation-1"
                                hide-default-footer
                                :items-per-page="-1"
                        >
                            <template v-slot:item.avatar="{ item }">
                                <v-avatar
                                        class="profile"
                                        color="grey"
                                        size="50"
                                >
                                    <v-img :src="item.avatar">
                                    </v-img>
                                </v-avatar>
                            </template>
<!--                            <template  v-if="bandAlreadyPassedList === true" v-slot:item.status="{ item }">-->
<!--                                <v-tooltip v-if="item.status === 0" bottom>-->
<!--                                    <template v-slot:activator="{ on, attrs }">-->
<!--                                        <v-btn-->
<!--                                                v-bind="attrs"-->
<!--                                                v-on="on"-->
<!--                                                small-->
<!--                                                dark-->
<!--                                                color="primary"-->
<!--                                                class="mr-2"-->
<!--                                                :loading="loading"-->
<!--                                                @click="changeAttendanceStudent(false, item.id)"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-check</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    <span>{{$t('remove_assistance')}}</span>-->
<!--                                </v-tooltip>-->
<!--                                <v-tooltip v-if="item.status === -1" bottom>-->
<!--                                    <template v-slot:activator="{ on, attrs }">-->
<!--                                        <v-btn-->
<!--                                                v-bind="attrs"-->
<!--                                                v-on="on"-->
<!--                                                small-->
<!--                                                dark-->
<!--                                                color="red"-->
<!--                                                class="mr-2"-->
<!--                                                :loading="loading"-->
<!--                                                @click="changeAttendanceStudent(true, item.id)"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-close</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    <span>{{$t('add_assistance')}}</span>-->
<!--                                </v-tooltip>-->
<!--                                <v-tooltip v-if="item.status > 0" bottom>-->
<!--                                    <template v-slot:activator="{ on, attrs }">-->
<!--                                        <v-btn-->
<!--                                                v-bind="attrs"-->
<!--                                                v-on="on"-->
<!--                                                small-->
<!--                                                color="primary"-->
<!--                                                class="mr-2"-->
<!--                                                disabled-->
<!--                                        >-->
<!--                                            <v-icon>mdi-check</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    <span>{{$t('attended')}}</span>-->
<!--                                </v-tooltip>-->
<!--                            </template>-->
<!--                            <template  v-if="bandAlreadyPassedList === true" v-slot:item.id="{ item }">-->
<!--                                <div v-if="item.status === -1">-->
<!--                                    {{$t('did_not_attend')}}-->
<!--                                </div>-->
<!--                                <div v-if="item.status === 0">-->
<!--                                    <v-btn-->
<!--                                            color="primary"-->
<!--                                            @click="signExitPass(item.id)"-->
<!--                                    >-->
<!--                                        {{$t('sign_exit')}}-->
<!--                                    </v-btn>-->
<!--                                </div>-->
<!--                                <div v-if="item.status === 1">-->
<!--                                    <v-icon color="green">mdi-check</v-icon>-->
<!--                                    {{$t('signed')}}-->
<!--                                </div>-->
<!--                                <div v-if="item.status === 2">-->
<!--                                    {{$t('out_of_school')}}-->
<!--                                </div>-->
<!--                            </template>-->
                        </v-data-table>
                        <v-divider/>
                        <br>
                        <h3>{{$t('step')}} 2</h3>
                        <p>{{$t('select_teacher_to_transfer_students')}}</p>
                        <v-autocomplete
                                v-model="idTeacher"
                                prepend-icon="mdi-human-male-board"
                                :items="teachers"
                                :item-text="example"
                                :filter="customFilterTeacher"
                                item-value="id"
                                :placeholder="$t('placeholder_invitados2')"
                                :label="$t('teacher')"
                                :error-messages="errores.idTeacher"
                                :no-data-text="$t('no_resultados')"
                                clearable
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        @click="data.select"
                                >
                                    <v-avatar left>
                                        <v-img :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.first_name }} {{data.item.last_name}}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                    <v-list-item-avatar>
                                        <img :src="data.item.avatar">
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                        <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </div>
                    <div v-else class="text-center">
                        <br>
                        <h2>{{$t('no_students_to_be_transferred')}}</h2>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-btn
                    v-if="dataListStudentsToSignExitPass.length !== 0"
                    color="primary"
                    block
                    :disabled="studentsSelectedToTransfer.length === 0 || (idTeacher === null || idTeacher === undefined)"
                    @click="dialog_transfer_confirm = true"
                  >
                    {{$t('transfer')}}
                  </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2>{{$t('list_students')}}</h2>
        <v-layout class="my-4" calign-center>
            <v-flex>
                <v-card class="elevation-5">
                    <v-card-text>
                        <v-layout row wrap class="my-4" calign-center justify-center fill-height>
                            <v-flex xs12>
                                <v-data-table
                                        :headers="headers"
                                        :loading="loadingDataClassroomByTeacher"
                                        :items="classroomsXTeacher"
                                        class="elevation-1"
                                        hide-default-footer
                                        :items-per-page="-1"
                                        :no-data-text="$t('no_classrooms')"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.grade_name }}</td>
                                        <td>{{ props.item.name }}</td>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        medium
                                                        color="grey"
                                                        class="mr-2"
                                                        @click="showListStudent(item.id), idClassroom = item.id"
                                                >
                                                    mdi-format-list-checks
                                                </v-icon>
                                            </template>
                                            <span>{{$t('attendance_list')}}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        medium
                                                        color="grey"
                                                        class="mr-2"
                                                        @click="getTeachers(),
                                                        idTeacher = null,
                                                        studentsSelectedToTransfer = [],
                                                        showListStudentToSignExitPass(item.id)"
                                                >
                                                    mdi-account-switch
                                                </v-icon>
                                            </template>
                                            <span>{{$t('transfer_students')}}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:no-results>
                                        <v-alert type="warning">
                                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import {mapGetters, mapState} from "vuex";

export default {
  name: "list",
  data () {
    return {
      loading: false,
      dialogSendList: false,
      // New Implementation
      classroomsXTeacher: [],
      loadingDataClassroomByTeacher: false,
      headers: [],
      dataListStudents: [],
      selected: [],
      studentsSelectedToTransfer: [],
      dialogListStudentsByClassroom: false,
      attendance: [],
      idClassroom: 0,
      dialogListStudentSignExitPass: false,
      dataListStudentsToSignExitPass: [],
      singleSelect: false,
      headers2: [],
      headers3: [],
      teachers: [],
      idTeacher: null,
      errores: [],
      bandAlreadyPassedList: false,
      AreThereStudentsAttendance: false,
      dialog_transfer_confirm: false,
      loading_transfer_confirm: false
    }
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
  },
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('grade'),
        align: 'left',
        sortable: true,
        value: 'grade_name'
      },
      {
        text: this.$t('nombre'),
        align: 'left',
        sortable: true,
        value: 'name'
      }
    ],
        this.headers2 = [
          {
            text: this.$t('photo'),
            align: 'center',
            sortable: false,
            value: 'avatar'
          },
          {
            text: this.$t('Apellido'),
            align: 'left',
            sortable: false,
            value: 'last_name'
          },
          {
            text: this.$t('Nombre'),
            align: 'left',
            sortable: false,
            value: 'first_name'
          },
          {
            text: this.$t('attended'),
            value: 'data-table-select'
          }
        ],
        this.headers3 = [
          {
            text: this.$t('photo'),
            align: 'center',
            sortable: false,
            value: 'avatar'
          },
          {
            text: this.$t('Apellido'),
            align: 'left',
            sortable: false,
            value: 'last_name'
          },
          {
            text: this.$t('Nombre'),
            align: 'left',
            sortable: false,
            value: 'first_name'
          },
          {
            text: this.$t('attended'),
            align: 'center',
            sortable: false,
            value: 'status'
          },
          {
            text: this.$t('estado'),
            align: 'center',
            sortable: false,
            value: 'id'
          }
        ]
  },
  created() {
    this.getClassroom ()
  },
  methods: {
    example: item => (item.first_name === null ? 'n/a' : item.first_name) + ' ' + (item.last_name === null ? 'n/a' : item.last_name),
    customFilterTeacher(item, queryText) {
      const textOne = item.first_name.toLowerCase()
      const textTwo = item.last_name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },
    getAreThereStudentsAttendance () {
      HTTP.get('classroom/' + this.idClassroom + '/list/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response.data)
        if(response.data.length > 0) {
          this.AreThereStudentsAttendance = true
          console.log('asistieron alumnos?', this.AreThereStudentsAttendance)
        }
        else {
          this.AreThereStudentsAttendance = false
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    getClassroom () {
      this.loadingDataClassroomByTeacher = true
      HTTP.get('classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        console.log(response.data)
        this.classroomsXTeacher = response.data
        this.loadingDataClassroomByTeacher = false
      })
      .catch(error => {
        this.loadingDataClassroomByTeacher = false
        console.log(error)
      })
    },
    alreadyPassedList (list) {
      let band = false

      console.log('Passed LIST')
      console.log(list)
      this.selected = []
      for(let i = 0; i < list.length ; i++) {
        if(list[i].status === 0 || list[i].status === 1 || list[i].status === 2 || list[i].status === 3) {
          this.selected.push(list[i])
          band = true
        }
      }
      return band
    },
    showListStudent(uuidClassroom) {
      HTTP.get('classroom/' + uuidClassroom + '/students/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.dataListStudents = response.data
        this.bandAlreadyPassedList = this.alreadyPassedList(response.data)
        console.log('Pasó lista?', this.bandAlreadyPassedList)
        this.dialogListStudentsByClassroom = true
      })
      .catch(error => {
        console.log(error)
      })
    },
    changeAttendanceStudent(attendance, uuidStudent) {
      let aux = []

      if (attendance === true) {
        this.loading = true
        aux.push({'idStudent': uuidStudent})
        HTTP.post('classroom/' + this.idClassroom + '/list/take/', aux,
        {
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          console.log(ok)
          this.showListStudent(this.idClassroom)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
      } else {
        this.loading = true
        aux.push({'idStudent': uuidStudent})
        HTTP.delete('classroom/' + this.idClassroom + '/list/remove/',
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          },
            data: aux
        })
        .then(ok => {
          console.log(ok)
          this.showListStudent(this.idClassroom)
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
      }
    },
    getTeachers () {
      let teachers = []

      HTTP.get('users/admins_and_teachers/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        for (let i = 0; i < response.data.length; i++) {
          if(response.data[i].id !== this.getProfile.id){
            teachers.push(response.data[i])
          }
        }
        this.teachers = teachers
      })
      .catch(error => {
        console.log(error)
      })
    },
    showListStudentToSignExitPass(uuidClassroom) {
      this.idClassroom = uuidClassroom
      this.getAreThereStudentsAttendance()
      HTTP.get('classroom/' + uuidClassroom + '/students/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.dialogListStudentSignExitPass = true
        let students = []
        for(let i = 0; i < response.data.length; i++) {
          if(response.data[i].status === 0) {
            students.push(response.data[i])
          }
        }
        this.dataListStudentsToSignExitPass = students
      })
      .catch(error => {
        console.log(error)
      })
    },
    signExitPass(uuidStudent) {
      var student = []

      student.push({
        'idStudent': uuidStudent
      })
      HTTP.patch('classroom/' + this.idClassroom + '/list/sign_pass/',
        student,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('sign_pass_success'))
        this.showListStudent(this.idClassroom)
        // setTimeout(this.clear, 3000)
      })
      .catch(error => {
        console.log(error)
      })
    },
    createExpressExit(uuidStudent) {
      this.loading = true
      var student = []

      student.push({
        'idStudent': uuidStudent
      })
      HTTP.post('express_exit/',
        student,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      // .then(ok => {
      //   this.loading = false
      //   console.log(ok)
      //   this.$store.commit('snackbar_activate_true')
      //   this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
      //   this.showListStudent(this.idClassroom)
      //   // setTimeout(this.clear, 3000)
      // })
      // .catch(error => {
      //   this.loading = false
      //   console.log(error)
      // })
      this.loading = false
      // console.log(ok)
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', this.$t('msg_alta_salida'))
      setTimeout(this.clear2, 1000)
    },
    sendList () {
      this.attendance = []
      for (let i =0; i < this.selected.length; i++) {
        this.attendance.push({
          'idStudent': this.selected[i].id
        })
        console.log(this.attendance)
      }
      HTTP.post('classroom/' + this.idClassroom + '/list/take/', this.attendance,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('attendance_list_sent_success'))
        this.dialogSendList = false
        this.showListStudent(this.idClassroom)
        // this.dialogListStudentsByClassroom = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        console.log(error)
      })
    },
    transferStudents () {
      this. errores = []
      this.loading_transfer_confirm = true
      if (this.idTeacher === undefined) {
          this.idTeacher = null
      }
      let attendance = []
      for (let i =0; i < this.studentsSelectedToTransfer.length; i++) {
        attendance.push({
          'idStudent': this.studentsSelectedToTransfer[i].id,
          'idUser': this.idTeacher
        })
        console.log(attendance)
      }
      HTTP.post('transferred/', attendance,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading_transfer_confirm = false
        console.log(ok)
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('transferred_students_successfully'))
        this.dialog_transfer_confirm = false
        this.dialogListStudentSignExitPass = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        this.loading_transfer_confirm = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
          if (error.response.data.non_field_errors)
            this.errores.idClassroom = error.response.data.non_field_errors
        }
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    clear2 () {
      this.showListStudent(this.idClassroom)
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>

</style>
